import type { ISection } from "~/types";

export const getOnlinePrimaryOrDefaultSection = (
  sections?: ISection[]
): ISection | undefined => {
  if (!sections?.length) return undefined;
  return (
    sections.find((s) => s.isPrimary && s.isOnline) ??
    sections.find((s) => s.isOnline)
  );
};
